<div [style.border-color]="color" class="list-element-container mt-1 flex align-center">
  <div [style.background]="color" class="circle flex align-center justify-center">
    <a [ngClass]="{'material-icons': icon}">{{ iconOrIndex }}</a>
  </div>
  <p>{{ text }}</p>
</div>
